import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, AlertController, Platform, LoadingController } from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { ImagePicker } from '@ionic-native/image-picker';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { DomSanitizer } from '@angular/platform-browser';
import { ImagenPage } from '../imagen/imagen';
import { FileChooser } from '@ionic-native/file-chooser';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { MapaPage } from '../mapa/mapa';

/**
 * Generated class for the SolicitudPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-solicitud',
  templateUrl: 'solicitud.html',
})
export class SolicitudPage {
  path:string=this.http.images
  pathPdf:string=this.http.pdf
  form: any = {
    razon: '',
    rif: '',
    tipoContrib: '',
    ciudad: '',
    estado: '',
    direccionFiscal: '',
    direccionEntrega: '',
    telefonoLocal: '',
    telefonoMovil: '',
    email: '',
    instagram: '',
    facebook: '',
    fachada: '',
    latitud: '',
    longitud: '',
    representCompania: [
      {
        representante: "",
        cedula: "",
        cargo: "",
        telefono: ""
      },
      {
        representante: "",
        cedula: "",
        cargo: "",
        telefono: ""
      },
      {
        representante: "",
        cedula: "",
        cargo: "",
        telefono: ""
      }
    ],
    representCompra: "",
    representCtaPagar: "",
    imgCIRepreL: '',
  }
  defaultForm: any = {
    razon: '',
    rif: '',
    tipoContrib: '',
    ciudad: '',
    estado: '',
    direccionFiscal: '',
    direccionEntrega: '',
    telefonoLocal: '',
    telefonoMovil: '',
    email: '',
    instagram: '',
    facebook: '',
    fachada: '',
    latitud: '',
    longitud: '',
    representCompania: [
      {
        representante: "",
        cedula: "",
        cargo: "",
        telefono: ""
      },
      {
        representante: "",
        cedula: "",
        cargo: "",
        telefono: ""
      },
      {
        representante: "",
        cedula: "",
        cargo: "",
        telefono: ""
      }
    ],
    representCompra: "",
    representCtaPagar: "",
    imgCIRepreL: '',
  }
  selectOptionsTipo: any = {
    title: 'Tipo de contribuyente',
  }
  cantRepre: any = 1
  loadModal: any
  errores: any = []
  UriCIRepreL: any
  UriFachada: any
  tipos: any = ["Ordinario", "Especial", "Formal"]
  cantidadImagenes: any
  view: any = false
  edit: any = false
  constructor(
    public navCtrl: NavController,
    private transfer: FileTransfer, 
    private fileChooser: FileChooser,
    private camera: Camera, 
    public platform: Platform,
    public navParams: NavParams,
    private iab: InAppBrowser,
    public imagePicker : ImagePicker, 
    public loadingCtrl: LoadingController,
    public sanitazer : DomSanitizer,
    public http: HttpProvider,
    public modal: ModalController,
    public alertCrtl: AlertController
  ) {
    if(window.localStorage.getItem('super')) {
      this.form.usuario = window.localStorage.getItem('id')
    } else {
      this.form.co_ven = window.localStorage.getItem('co_ven')
    }
  }

  agrandar(cod){
    this.navCtrl.push(ImagenPage, {value: cod})
  }

  transformS(item) {
    return JSON.stringify(item)
  }

  countChange(event) {
    event.value = event.value.replace(/[^0-9]*/g, '');
  }

  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }

  DesactivarLoading() {
    this.loadModal.dismiss();
  }

  limpiar() {
    this.form = Object.assign({}, this.defaultForm);
    this.UriCIRepreL = ""
  }
  
  validarImagenes() {
    this.cantidadImagenes = []
    if (this.UriFachada) this.cantidadImagenes.push({img: this.form.fachada, filename: "fachada", index: null})
    if (this.form.imgCIRepreL) this.cantidadImagenes.push({img: this.form.imgCIRepreL, filename: "CIRepreL", index: null})
    return (this.cantidadImagenes.length > 0) ? true : false
  }
  
  validarImagenes2() {
    this.cantidadImagenes = []
    if (this.UriFachada) this.cantidadImagenes.push({img: this.form.fachada, filename: "fachada", index: null})
    if (this.UriCIRepreL) this.cantidadImagenes.push({img: this.form.imgCIRepreL, filename: "CIRepreL", index: null})
    return (this.cantidadImagenes.length > 0) ? true : false
  }

  verificarMimeType(item) {
    if (item.includes(".pdf")) {
      return "application/pdf"
    } else {
      return "image/jpeg"
    }
  }

  async operacion(res, el, i) {
    return await new Promise(async (resolve) =>{
      const fileTransfer: FileTransferObject = this.transfer.create();
      let options: FileUploadOptions = {
        httpMethod: 'PUT',
        params: res,
        fileKey: 'file',
        fileName: el.filename,
        mimeType: this.verificarMimeType(el.img),
        headers: {}
      }
      await fileTransfer.upload(el.img, this.http.path + 'solicitudes/imagenes', options)
      .then((res:any) => {
        // success
        if (i === (this.cantidadImagenes.length - 1)) {
          this.form = Object.assign({}, this.defaultForm);
          this.DesactivarLoading()
          resolve("listo")
          let msg = (this.errores.length === 0) ? 'La solicitud ha sido registrada exitosamente' : 'La solicitud ha sido registrada con problemas, las imagenes a continuación no fueron registradas exitosamente: ' + this.errores
          this.alertCrtl.create({
            title:'Información',
            subTitle: msg,
            buttons:[
              {
                cssClass:'btnAceptar',
                text:'Aceptar',
                handler:()=>{
                  this.navCtrl.pop()
                }
              }
            ]
          }).present()
        } else {
          resolve(i)
        }
      }, (err) => {
        // error
        this.errores.push(el.filename)
        this.DesactivarLoading()
        resolve(err)
      })
    })
  }

  async registrar(){
    if(window.localStorage.getItem('network') === '1') {
      this.ActivarLoading()
      this.http.post('solicitudes', this.form).subscribe(
        async (res:any) => {
          if (this.validarImagenes()) {
            for (let i = 0; i < this.cantidadImagenes.length; i++) {
              let el = this.cantidadImagenes[i]
              res.indexado = el.index
              await this.operacion(res, el, i)
            }
          } else {
            this.form = Object.assign({}, this.defaultForm);
            this.DesactivarLoading()
            this.alertCrtl.create({
              title:'Información',
              subTitle:'La solicitud ha sido registrada exitosamente',
              buttons:[
                {
                  cssClass:'btnAceptar',
                  text:'Aceptar',
                  handler:()=>{
                    this.navCtrl.pop()
                  }
                }
              ]
            }).present()
          }
        },
        err => {
          console.log(err)
          this.alertCrtl.create({
            title:'Atención',
            subTitle:'Error de conexión, intente nuevamente o llame al administrador.',
            buttons:[{
              cssClass:'btnAceptar',
              text:'Aceptar'
            }]
          }).present()
          this.DesactivarLoading()
        }
      )
    } else {
      this.alertCrtl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

  async editar() {
    if(window.localStorage.getItem('network') === '1') {
      this.ActivarLoading()
      this.http.put('solicitudes', this.form).subscribe(
        async (res:any) => {
          console.log(res)
          if (this.validarImagenes2()) {
            for (let i = 0; i < this.cantidadImagenes.length; i++) {
              let el = this.cantidadImagenes[i]
              res.indexado = el.index
              await this.operacion(res, el, i)
            }
          } else {
            this.form = Object.assign({}, this.defaultForm);
            this.DesactivarLoading()
            this.alertCrtl.create({
              title:'Información',
              subTitle:'La solicitud ha sido registrada exitosamente',
              buttons:[
                {
                  cssClass:'btnAceptar',
                  text:'Aceptar',
                  handler:()=>{
                    this.navCtrl.pop()
                  }
                }
              ]
            }).present()
          }
        },
        err => {
          console.log(err)
          this.alertCrtl.create({
            title:'Atención',
            subTitle:'Error de conexión, intente nuevamente o llame al administrador.',
            buttons:[{
              cssClass:'btnAceptar',
              text:'Aceptar'
            }]
          }).present()
          this.DesactivarLoading()
        }
      )
    } else {
      this.alertCrtl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

  restarAndClean(item, valor) {
    if (item === "Representantes") {
      this.form.representCompania[valor].representante = ""
      this.form.representCompania[valor].cedula = ""
      this.form.representCompania[valor].cargo = ""
      this.form.representCompania[valor].telefono = ""
      this.cantRepre = valor
    }
  }

  borrar(item, index) {
    if (item === "CIRepreL") {
      this.UriCIRepreL = ""
      this.form.imgCIRepreL = ""
    }
    if (item === "Fachada") {
      this.UriFachada = ""
      this.form.fachada = ""
    }
  }

  showConfirm(item) {
    const confirm = this.alertCrtl.create({
      title: 'Seleccione',
      buttons: [
        {
          text: 'Imagen',
          cssClass:'btn',
          handler: () => {
            this.getImage(item, "i")
          }
        },
        {
          text: 'Camara',
          cssClass:'btn',
          handler: () => {
            this.getImage(item,'c')
          }
        },
        {
          text: 'PDF',
          cssClass:'btn',
          handler: () => {
            this.getImage(item, "p")
          }
        },
        {
          text: 'Salir',
          cssClass:'btnAceptar',
          handler: () => {
          }
        }
      ]
    });
    confirm.present();
  }

  async abrirModal() {
    let modl = this.modal.create(MapaPage)
    modl.onDidDismiss(data => {
      if (data) {
        this.form.latitud = data.lat
        this.form.longitud = data.lng
      }
    });
    modl.present();
  }

  abrirPdf(item) {
    this.iab.create(this.pathPdf + item, '_system');
  }

  verificarPdf(item) {
    if (item.includes(".pdf")) {
      return true
    } else {
      return false
    }
  }

  getImage(item, tipo) {
    this.imagePicker.hasReadPermission().then(res=>{
      if (res) {
        if (tipo === "i") {
          let optionsImg: CameraOptions = {
            quality:100,
            destinationType: this.camera.DestinationType.FILE_URI,
            encodingType: this.camera.EncodingType.JPEG,
            mediaType: this.camera.MediaType.PICTURE,
            sourceType: this.camera.PictureSourceType.SAVEDPHOTOALBUM,
            allowEdit: false
          }
  
          this.camera.getPicture(optionsImg).then(
            res=>{
              if(this.platform.is('android')){
                if (item === "CIRepreL") {
                  this.UriCIRepreL = (<any>window).Ionic.WebView.convertFileSrc(res)
                  this.form.imgCIRepreL = res
                }
                if (item === "Fachada") {
                  this.UriFachada = (<any>window).Ionic.WebView.convertFileSrc(res)
                  this.form.fachada = res
                }
              }else{
                if (item === "CIRepreL") {
                  this.UriCIRepreL = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
                  this.form.imgCIRepreL = res
                }
                if (item === "Fachada") {
                  this.UriFachada = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
                  this.form.fachada = res
                }
              }
            },
            error=>console.log(error)
          )
        } else if (tipo == "p") {
          this.fileChooser.open()
          .then(res => {
            if (res.includes(".pdf")) {
              if(this.platform.is('android')){
                if (item === "CIRepreL") {
                  this.UriCIRepreL = (<any>window).Ionic.WebView.convertFileSrc(res)
                  this.form.imgCIRepreL = res
                }
                if (item === "Fachada") {
                  this.UriFachada = (<any>window).Ionic.WebView.convertFileSrc(res)
                  this.form.fachada = res
                }
              }else{
                if (item === "CIRepreL") {
                  this.UriCIRepreL = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
                  this.form.imgCIRepreL = res
                }
                if (item === "Fachada") {
                  this.UriFachada = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
                  this.form.fachada = res
                }
              }
            } else {
              this.alertCrtl.create({
                title:'Atención',
                subTitle: 'Formato seleccionado no permitido.',
                buttons:[
                  {
                    cssClass:'btnAceptar',
                    text:'Aceptar',
                    handler:()=>{
                      
                    }
                  }
                ]
              }).present()
            }
          })
          .catch(e => console.log(e));
        } else {
          let optionsImg: CameraOptions = {
            quality:100,
            destinationType: this.camera.DestinationType.FILE_URI,
            encodingType: this.camera.EncodingType.JPEG,
            mediaType: this.camera.MediaType.PICTURE,
            sourceType: this.camera.PictureSourceType.CAMERA,
            allowEdit: false
          }
          this.camera.getPicture(optionsImg).then(
            res=>{
              if(this.platform.is('android')){
                if (item === "CIRepreL") {
                  this.UriCIRepreL = (<any>window).Ionic.WebView.convertFileSrc(res)
                  this.form.imgCIRepreL = res
                }
                if (item === "Fachada") {
                  this.UriFachada = (<any>window).Ionic.WebView.convertFileSrc(res)
                  this.form.fachada = res
                }
              }else{
                if (item === "CIRepreL") {
                  this.UriCIRepreL = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
                  this.form.imgCIRepreL = res
                }
                if (item === "Fachada") {
                  this.UriFachada = this.sanitazer.bypassSecurityTrustResourceUrl((<any>window).Ionic.WebView.convertFileSrc(res))
                  this.form.fachada = res
                }
              }
            },
            error=>console.log(error)
          )
        }
      } else {
        this.imagePicker.requestReadPermission()
      }
    }).catch(err=>{
      this.alertCrtl.create({
        title:'Atención',
        subTitle:err,
        buttons:[{
          cssClass:'btnAceptar',
          text:'Aceptar'
        }]
      }).present()
    })
  }

  ionViewDidLoad() {
  }

  ionViewDidEnter() {
    if (this.navParams.get("value")) {
      let val = JSON.parse(this.navParams.get("value"))
      Object.keys(this.form).map(key => {
        if (val[key]) this.form[key] = val[key];
      });
      this.form._id = val._id
      this.cantRepre = 3
      if (this.navParams.get("edit")) {
        this.edit = true
      } else {
        this.view = true
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/solicitud/solicitud.ts